<template>
  <div id="sm">
    <p>$$$url> $$$loc>https://ottwatchlist.com/$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/mustwatch$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/newupdates$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/kids$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/articles$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/watchlist$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/about$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/privacy$$$/loc> $$$/url> $$$url></p>
    <p>$$$loc>https://ottwatchlist.com/termsServices$$$/loc> $$$/url></p>

    <p v-for="d in data" :key="d.id">
      $$$loc>https://ottwatchlist.com/articles/{{ d.id }}/{{ d.slug }} $$$/loc>
      $$$/url>
    </p>
  </div>
</template>

<script>
export default {
  data: () => ({
    data: {},
  }),
  created() {
    this.$Parse.Cloud.run("getArticlesTitle")
      .then((res) => {
        this.data = res.items.map(function (obj) {
          const searchRegExp = /\s/g;
          const replaceWith = "-";
          obj.slug = obj.title.replace(searchRegExp, replaceWith);
          return obj;
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
#sm {
  background-color: black;
}
</style>
